"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getZapLastPausedAt({ last_paused_at, }) {
    return last_paused_at;
}
exports.default = getZapLastPausedAt;
